// this file is shared frontend and backend
export const AUPRED_PROMPT_FUNC = (botName) => `להלן צילום ש${botName} תפס במצלמת הרשת שלו:` // gpt recommends non-empty to avoid llm repetition

